import {CUSTOMER_INSIGHTS_REDUX_STORE} from "./AppConstants";
import {initialStateData} from './reducer';

export const loadState = () => {
  try {
    let serializedState = localStorage.getItem(CUSTOMER_INSIGHTS_REDUX_STORE);
    if (null === serializedState) {
      return initialStateData;
    } else {
      return JSON.parse(serializedState);
    }
  } catch (e) {
    console.log("Error in loadState of storeStateLoader", e);
    return initialStateData;
  }
}

export const saveState = (reduxStateData) => {
  try {
    let serializedState = JSON.stringify(reduxStateData);
    localStorage.setItem(CUSTOMER_INSIGHTS_REDUX_STORE, serializedState);
  } catch (e) {
    console.log("Error in saveState of storeStateLoader", e);
  }
}


